import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import { SpotForRoutingFragmentDoc } from '../../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetSpotQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetSpotQuery = { __typename?: 'QueryRoot', spot: { __typename?: 'Spot', id: string, assetId: number, courseId: string, spotType: Types.SpotType, name?: string | null, description?: string | null, order: number, parentSpotId?: string | null, note?: string | null, hasMusic: boolean, coordinate: { __typename?: 'Coordinate', lat: number, lon: number } } };

export type GetCourseAssetQueryVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
  assetType: Types.CourseAssetType;
}>;


export type GetCourseAssetQuery = { __typename?: 'QueryRoot', getCourseAsset: { __typename?: 'AssetSource', id: string, source: Array<number> } };

export type GetSpotAssetQueryVariables = Types.Exact<{
  spotId: Types.Scalars['String'];
  assetType: Types.SpotAssetType;
}>;


export type GetSpotAssetQuery = { __typename?: 'QueryRoot', getSpotAsset: { __typename?: 'AssetSource', id: string, source: Array<number> } };

export type UpdateCourseAssetMutationVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
  assetType: Types.CourseAssetType;
  source: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type UpdateCourseAssetMutation = { __typename?: 'MutationRoot', updateCourseAsset: { __typename?: 'AssetSource', id: string } };

export type UpdateSpotAssetMutationVariables = Types.Exact<{
  spotId: Types.Scalars['String'];
  assetType: Types.SpotAssetType;
  source: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type UpdateSpotAssetMutation = { __typename?: 'MutationRoot', updateSpotAsset: { __typename?: 'AssetSource', id: string } };

export type RemoveCourseAssetMutationVariables = Types.Exact<{
  courseId: Types.Scalars['String'];
  assetType: Types.CourseAssetType;
}>;


export type RemoveCourseAssetMutation = { __typename?: 'MutationRoot', removeCourseAsset: { __typename?: 'AssetSource', id: string } };

export type RemoveSpotAssetMutationVariables = Types.Exact<{
  spotId: Types.Scalars['String'];
  assetType: Types.SpotAssetType;
}>;


export type RemoveSpotAssetMutation = { __typename?: 'MutationRoot', removeSpotAsset: { __typename?: 'AssetSource', id: string } };


export const GetSpotDocument = gql`
    query GetSpot($id: String!) {
  spot(id: $id) {
    ...SpotForRouting
  }
}
    ${SpotForRoutingFragmentDoc}`;

export function useGetSpotQuery(options: Omit<Urql.UseQueryArgs<GetSpotQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSpotQuery, GetSpotQueryVariables>({ query: GetSpotDocument, ...options });
};
export const GetCourseAssetDocument = gql`
    query GetCourseAsset($courseId: String!, $assetType: CourseAssetType!) {
  getCourseAsset(courseId: $courseId, assetType: $assetType) {
    id
    source
  }
}
    `;

export function useGetCourseAssetQuery(options: Omit<Urql.UseQueryArgs<GetCourseAssetQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCourseAssetQuery, GetCourseAssetQueryVariables>({ query: GetCourseAssetDocument, ...options });
};
export const GetSpotAssetDocument = gql`
    query GetSpotAsset($spotId: String!, $assetType: SpotAssetType!) {
  getSpotAsset(spotId: $spotId, assetType: $assetType) {
    id
    source
  }
}
    `;

export function useGetSpotAssetQuery(options: Omit<Urql.UseQueryArgs<GetSpotAssetQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSpotAssetQuery, GetSpotAssetQueryVariables>({ query: GetSpotAssetDocument, ...options });
};
export const UpdateCourseAssetDocument = gql`
    mutation UpdateCourseAsset($courseId: String!, $assetType: CourseAssetType!, $source: [Int!]!) {
  updateCourseAsset(
    input: {id: $courseId, assetType: $assetType, source: $source}
  ) {
    id
  }
}
    `;

export function useUpdateCourseAssetMutation() {
  return Urql.useMutation<UpdateCourseAssetMutation, UpdateCourseAssetMutationVariables>(UpdateCourseAssetDocument);
};
export const UpdateSpotAssetDocument = gql`
    mutation UpdateSpotAsset($spotId: String!, $assetType: SpotAssetType!, $source: [Int!]!) {
  updateSpotAsset(input: {id: $spotId, assetType: $assetType, source: $source}) {
    id
  }
}
    `;

export function useUpdateSpotAssetMutation() {
  return Urql.useMutation<UpdateSpotAssetMutation, UpdateSpotAssetMutationVariables>(UpdateSpotAssetDocument);
};
export const RemoveCourseAssetDocument = gql`
    mutation RemoveCourseAsset($courseId: String!, $assetType: CourseAssetType!) {
  removeCourseAsset(input: {id: $courseId, assetType: $assetType}) {
    id
  }
}
    `;

export function useRemoveCourseAssetMutation() {
  return Urql.useMutation<RemoveCourseAssetMutation, RemoveCourseAssetMutationVariables>(RemoveCourseAssetDocument);
};
export const RemoveSpotAssetDocument = gql`
    mutation RemoveSpotAsset($spotId: String!, $assetType: SpotAssetType!) {
  removeSpotAsset(input: {id: $spotId, assetType: $assetType}) {
    id
  }
}
    `;

export function useRemoveSpotAssetMutation() {
  return Urql.useMutation<RemoveSpotAssetMutation, RemoveSpotAssetMutationVariables>(RemoveSpotAssetDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSpotQuery((req, res, ctx) => {
 *   const { id } = req.variables;
 *   return res(
 *     ctx.data({ spot })
 *   )
 * })
 */
export const mockGetSpotQuery = (resolver: ResponseResolver<GraphQLRequest<GetSpotQueryVariables>, GraphQLContext<GetSpotQuery>, any>) =>
  graphql.query<GetSpotQuery, GetSpotQueryVariables>(
    'GetSpot',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCourseAssetQuery((req, res, ctx) => {
 *   const { courseId, assetType } = req.variables;
 *   return res(
 *     ctx.data({ getCourseAsset })
 *   )
 * })
 */
export const mockGetCourseAssetQuery = (resolver: ResponseResolver<GraphQLRequest<GetCourseAssetQueryVariables>, GraphQLContext<GetCourseAssetQuery>, any>) =>
  graphql.query<GetCourseAssetQuery, GetCourseAssetQueryVariables>(
    'GetCourseAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSpotAssetQuery((req, res, ctx) => {
 *   const { spotId, assetType } = req.variables;
 *   return res(
 *     ctx.data({ getSpotAsset })
 *   )
 * })
 */
export const mockGetSpotAssetQuery = (resolver: ResponseResolver<GraphQLRequest<GetSpotAssetQueryVariables>, GraphQLContext<GetSpotAssetQuery>, any>) =>
  graphql.query<GetSpotAssetQuery, GetSpotAssetQueryVariables>(
    'GetSpotAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCourseAssetMutation((req, res, ctx) => {
 *   const { courseId, assetType, source } = req.variables;
 *   return res(
 *     ctx.data({ updateCourseAsset })
 *   )
 * })
 */
export const mockUpdateCourseAssetMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateCourseAssetMutationVariables>, GraphQLContext<UpdateCourseAssetMutation>, any>) =>
  graphql.mutation<UpdateCourseAssetMutation, UpdateCourseAssetMutationVariables>(
    'UpdateCourseAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSpotAssetMutation((req, res, ctx) => {
 *   const { spotId, assetType, source } = req.variables;
 *   return res(
 *     ctx.data({ updateSpotAsset })
 *   )
 * })
 */
export const mockUpdateSpotAssetMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateSpotAssetMutationVariables>, GraphQLContext<UpdateSpotAssetMutation>, any>) =>
  graphql.mutation<UpdateSpotAssetMutation, UpdateSpotAssetMutationVariables>(
    'UpdateSpotAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveCourseAssetMutation((req, res, ctx) => {
 *   const { courseId, assetType } = req.variables;
 *   return res(
 *     ctx.data({ removeCourseAsset })
 *   )
 * })
 */
export const mockRemoveCourseAssetMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveCourseAssetMutationVariables>, GraphQLContext<RemoveCourseAssetMutation>, any>) =>
  graphql.mutation<RemoveCourseAssetMutation, RemoveCourseAssetMutationVariables>(
    'RemoveCourseAsset',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveSpotAssetMutation((req, res, ctx) => {
 *   const { spotId, assetType } = req.variables;
 *   return res(
 *     ctx.data({ removeSpotAsset })
 *   )
 * })
 */
export const mockRemoveSpotAssetMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveSpotAssetMutationVariables>, GraphQLContext<RemoveSpotAssetMutation>, any>) =>
  graphql.mutation<RemoveSpotAssetMutation, RemoveSpotAssetMutationVariables>(
    'RemoveSpotAsset',
    resolver
  )
